import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getWorkingArea = createAsyncThunk(
  "admin/working-area",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/working-area", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getWorkingAreaById = createAsyncThunk(
  "admin/working-area/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/working-area/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortWorkingArea = createAsyncThunk(
  "admin/working-area/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/working-area/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postWorkingArea = createAsyncThunk(
  "admin/working-area/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/working-area", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteWorkingArea = createAsyncThunk(
  "admin/working-area/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/working-area/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateWorkingArea = createAsyncThunk(
  "admin/working-area/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/working-area/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const workingAreaSlice = createSlice({
  name: "Working Area Store",
  initialState: initialState,
  reducers: {
    addWorkingArea(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortWorkingArea(state, action) {
      state.data.docs = action.payload;
    },
    deleteWorkingArea(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editWorkingArea(state, action) {
      state.data.docs = state.data.docs.map((item) =>
        item._id === action.payload._id ? action.payload : item
      ); 
      state.data.docs.shift();
    },
  },
  extraReducers: {
    [getWorkingArea.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getWorkingArea.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getWorkingArea.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getWorkingAreaById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getWorkingAreaById.fulfilled]: (state, action) => {
      state.data.docs.unshift(action.payload.data);
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getWorkingAreaById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortWorkingArea.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortWorkingArea.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortWorkingArea.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postWorkingArea.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postWorkingArea.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postWorkingArea.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteWorkingArea.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteWorkingArea.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteWorkingArea.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateWorkingArea.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateWorkingArea.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateWorkingArea.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const workingAreaActions = workingAreaSlice.actions;

export default workingAreaSlice.reducer;
